export default "__VITE_ASSET__9bff2e3e__"